import { axios } from "src/common/utils";
import authHeader from "src/common/auth/authHeader";

const VendorRegisService = {};

VendorRegisService.getCurrentForm = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/GetCurrentForm`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.ddlVersion = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/DdlVersion`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.ddlVersionTab2 = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/DdlVersion?statusForm=2`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.ddlStatus = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/DdlStatus`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.ddlStatusTab2 = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/DdlStatusTab2`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.ddlEvaluate = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/DdlEvaluate`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.GridESGData = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/GridESGData`,
      data: {
          lang: data.lang,
          version: data.version,
          evaluationName: data.evaluationName,
          status: data.status,
          vatRegistrationNo: data.vatRegistrationNo
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

VendorRegisService.GridESGDataHistory = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/GridESGDataHistory`,
      data: {
          lang: data.lang,
          version: data.version,
          // evaluationName: data.evaluationName,
          status: data.status,
          evaluate: data.evaluate,
          vatRegistrationNo: data.vatRegistrationNo
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};


VendorRegisService.getActiveBtnNew = (vatRegistrationNo) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/VendorRegisESG/GetActiveBtnNew?RegistrationNo=`+vatRegistrationNo,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export default VendorRegisService;